export const formValues = {
  asset_id: null,
  asset_type_id: null,
  ata_chapter: null,
  repair_ref_number: null,
  repair_type: "DENT",
  repair_description: null,
  repair_inspection: null,
  repair_location: null,
  repair_detail: null,
  repair_compliance_tsn: null,
  repair_compliance_csn: null,
  repair_compliance_date: null,
  repair_compliance_ref: null,
  repair_status: "OPEN",
  repair_DUE: null,
  last_done_date: null,
  last_done_fh: null,
  last_done_fc: null,
  dnb_compliance_dfp: null,
  release_certificate: null,
  certificate_of_conformity: null,
  srm_ref_document: null,
  oem_repair_scheme: null,
  faa_equivalent: null,
  remark: null,
  attachments: [],
  checklist:[],
  repair_interval_type: "D",
  repair_interval: null,
  folder_uuid:null
}

